import { z } from 'zod';

export const WeaknessSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    _id: z.string().optional(),
    tenantId: z.string().optional(),
    name: z.string().min(1, "form.validation.weaknessNameRequired").max(255, "form.validation.weaknessNameTooLong"),
    description: z.string().min(1, "form.validation.descriptionRequired").max(1000, "form.validation.descriptionTooLong"),
    severity: z.string().optional(),
    assetId: z.string().optional(),
    status: z.preprocess(
        (value) => (typeof value === "string" ? value.toLowerCase() : value),
        z.enum(["active", "inactive"]).optional()
    ),
    createdDate: z.union([z.string(), z.date()]).optional(),
    lastUpdated: z.union([z.string(), z.date()]).optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateWeaknessSchema = WeaknessSchema.omit({ id: true, _id: true, createdDate: true, lastUpdated: true });
export const UpdateWeaknessSchema = WeaknessSchema.partial();

// Frontend Form Schema
export const WeaknessFormSchema = WeaknessSchema.omit({
    id: true,
    _id: true,
    tenantId: true,
    createdDate: true,
    lastUpdated: true,
});